import {Button} from '@/components-v2/atoms'
import {ButtonGroup} from '@/components-v2/molecules/ButtonGroup/ButtonGroup'

/**
 * @param {{
 *   handleCancel: () => void;
 *   draftAction: () => void;
 *   nextAction: () => void;
 *   isReview?: boolean;
 *   hideSaveDraft?: boolean;
 *   FormError?: boolean;
 *   isLoading?: boolean;
 *   isSaveDraftDisabled?: boolean;
 * }} props
 */
export const SaveCancelFooter = ({
  handleCancel,
  draftAction,
  nextAction,
  isReview = false,
  hideSaveDraft = false,
  FormError = false,
  isLoading = false,
  isSaveDraftDisabled = false,
}) => {
  return (
    <div className="flex justify-between py-4">
      <ButtonGroup
        size="medium"
        items={[
          {label: 'Cancel', onClick: handleCancel},
          ...(!hideSaveDraft ? [{label: 'Save Draft', onClick: draftAction, disabled: isSaveDraftDisabled}] : []),
        ]}
      />
      <Button
        variant="primary"
        size="medium"
        iconTrailing="arrow_forward"
        disabled={FormError}
        isLoading={isLoading}
        onClick={nextAction}
      >
        {isReview ? 'Publish' : 'Next'}
      </Button>
    </div>
  )
}
